export default __webpack_public_path__ + "static/media/female-endomorph.31550b92.svg";